import { post } from "../utils/Backend";
import { uploadAppFileToOss } from "../global/OssUploadApi";
import { useH5Mock } from "../global/GlobalMock";
import { compressFileToJpegFile } from "../utils/imageCompressToJpeg";
import { mockUpdateProfile, mockUploadAvatar } from "./UserProfileMock";

export type UpdateProfileParam = {
  nickname: string;
  avatarUrl: string;
  gender: string;
  birthday: string;
};

const updateProfile = async (p: UpdateProfileParam): Promise<boolean> => {
  if (useH5Mock) {
    return mockUpdateProfile(p);
  }
  const res = await post<UpdateProfileParam, boolean>("/lark/app/user/updateProfile", {
    nickname: p.nickname.trim(),
    avatarUrl: p.avatarUrl.trim(),
    gender: p.gender,
    birthday: p.birthday.trim(),
  });
  if (typeof res === "string") {
    return false;
  }
  return !!res;
};

const uploadAvatarFromCompressedFile = async (file: File): Promise<string | null> => {
  if (useH5Mock) {
    return mockUploadAvatar(file);
  }
  let uploadFile: File = file;
  try {
    uploadFile = await compressFileToJpegFile(file, 640, 0.86);
  } catch {
    // iOS 相册 HEIC 等格式在 canvas 压缩可能失败，回退原图直传
    uploadFile = file;
  }
  try {
    return await uploadAppFileToOss(uploadFile, "USER_AVATAR");
  } catch {
    return null;
  }
};

export const UserProfileApi = {
  updateProfile,
  uploadAvatarFromCompressedFile,
};
